var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learning-meta",class:{
		'space-children-inline-regular': !_vm.isReduced,
		'space-children-inline-tight': _vm.isReduced,
	}},[(_vm.learningItem.showAccreditedBadge)?_c('accredited-badge',{class:{
			'badge--small': !_vm.isReduced,
			'badge--tiny': _vm.isReduced,
		}}):_vm._e(),_c('total-credits-badge',{class:{
			'badge--small': !_vm.isReduced,
			'badge--tiny': _vm.isReduced,
		},attrs:{"learning-item":_vm.learningItem,"hide-if-zero":!_vm.isAdminView}}),(_vm.isAdminView || _vm.learningItem.credits > 0)?_c('completion-credits-badge',{class:{
			'badge--small': !_vm.isReduced,
			'badge--tiny': _vm.isReduced,
		},attrs:{"credits":_vm.learningItem.credits}}):_vm._e(),(_vm.learningItem.sendCertificate)?_c('certificate-badge',{class:{
			'badge--small': !_vm.isReduced,
			'badge--tiny': _vm.isReduced,
		},attrs:{"is-disabled":!_vm.learningItem.sendCertificate,"start-date":_vm.learningItem.sendCertificateDateStart}}):_vm._e(),(_vm.learningItem.identifier)?_c('span',{class:{
			'text-regular': !_vm.isReduced,
			'text-small': _vm.isReduced,
		}},[_vm._v(" "+_vm._s(_vm.$t('id-label', [_vm.learningItem.identifier]))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }